import { render, staticRenderFns } from "./PriorityCombo.vue?vue&type=template&id=5a7b02dc&"
import script from "./PriorityCombo.vue?vue&type=script&lang=ts&"
export * from "./PriorityCombo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports